import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/rule-title.png'
import _imports_1 from '../assets/img/rule-text1.png'
import _imports_2 from '../assets/img/rule-text2.png'


const _hoisted_1 = { class: "rule-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "rule-title",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "rule-content" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rule-text",
    src: _imports_1
  }),
  /*#__PURE__*/_createVNode("img", {
    class: "rule-text",
    src: _imports_2
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShareBtn = _resolveComponent("ShareBtn")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_ShareBtn)
  ]))
}